export default "__VITE_ASSET__CemDCTVS__"